// removed by extract-text-webpack-plugin
module.exports = {"profileIcon":"_38zH1"};


//////////////////
// WEBPACK FOOTER
// ../src/components/ProfileIcon/ProfileIcon.css
// module id = 259
// module chunks = 0